import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../ts/ServerApi/types/actionParams';
import { FlowAllowedActions } from '../types/FlowAllowedActions';

export class GetFlowActionsRequest extends Request<ISingleIdParams, FlowAllowedActions> {
  constructor(id: string) {
    super('getFlowActions', { id: id });
  }
}
